import { render } from "./ShipmentStockTakeUserAssignment.vue?vue&type=template&id=66f7e824&scoped=true"
import script from "./ShipmentStockTakeUserAssignment.vue?vue&type=script&lang=js"
export * from "./ShipmentStockTakeUserAssignment.vue?vue&type=script&lang=js"

import exportComponent from "/home/adrianhardy/projects/Clients/O/Orchard_Crown_Ltd/ionic-storeroom/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66f7e824"]])

export default __exports__